import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/app-shell";
import { RequireAuth } from "@/components/require-auth";
import { RequireScope } from "@/components/require-scope";
import Login from "@/pages/login";
import SelectGate from "@/pages/select-gate";
import Today from "@/pages/today";
import Scan from "@/pages/scan";
import Orders from "@/pages/orders";
import OrderPage from "@/pages/order";
import Log from "@/pages/log";
import Admin from "@/pages/admin";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* After sign-in: pick the gate for this session (auto-picked when there is only one). */}
      <Route
        path="/select-gate"
        element={
          <RequireAuth>
            <SelectGate />
          </RequireAuth>
        }
      />

      {/* Inside the shell: a session; the guard screens also need a chosen gate. The admin screen
          does not — an admin setting up the first gate has none to pick yet. */}
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route
          path="/"
          element={
            <RequireScope>
              <Today />
            </RequireScope>
          }
        />
        <Route
          path="/scan"
          element={
            <RequireScope>
              <Scan />
            </RequireScope>
          }
        />
        <Route
          path="/orders"
          element={
            <RequireScope>
              <Orders />
            </RequireScope>
          }
        />
        <Route
          path="/order/:id"
          element={
            <RequireScope>
              <OrderPage />
            </RequireScope>
          }
        />
        <Route
          path="/log"
          element={
            <RequireScope>
              <Log />
            </RequireScope>
          }
        />
        <Route path="/admin" element={<Admin />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
